// Add your custom JS here.

(function($) {

  //to-top
  $(function() {
      let showFlag = false;
      const topBtn = $('.to-top');    
      topBtn.css('bottom', '-100px');
      //スクロールが100に達したらボタン表示
      $(window).on('scroll', function () {
          if ($(this).scrollTop() > 100) {
              if (showFlag == false) {
                  showFlag = true;
                  topBtn.stop().animate({'bottom' : '10px'}, 200); 
              }
          } else {
              if (showFlag) {
                  showFlag = false;
                  topBtn.stop().animate({'bottom' : '-100px'}, 200); 
              }
          }
      })
  })
  
  // page-link-scroll
  $(function() {
    let headerHeight = 0;
    headerHeight = $('#main-nav').outerHeight();
    let urlHash = location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        scrollToAnker(urlHash);
      }, 100);
    }
    $('a.link-scroll, a.nav-link').on('click', function(){
      let href= $(this).attr('href').replace(/.*#/, '');
      let hash = '#' + href;
      scrollToAnker(hash);
      return false;
    })
    function scrollToAnker(hash) {
      let target = $(hash);
      if(target.length){
        let position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, 500);
        return false;
      }
    }
  })


  // main-nav スクロール処理
  $(function() {
    $(window).on('load scroll', function() {
      if ($(this).scrollTop() > 120) {
        $('#main-nav').addClass('nav-scrolled');
      } else {
        $('#main-nav').removeClass('nav-scrolled');
      }
    });
  })



	// global-templates/side-banner_slide.php 使用しない
  /*
  $(function() {
    const myCarousel = document.querySelector('#banner-block');
    if(myCarousel) {
      const carousel = new understrap.Carousel(myCarousel, {
        interval: 3000
      });
    }
  })
  */


  // Contact Form 7 Multi-Step Forms
  // 戻るでdisabledを外す
  $(function() {
    if($('#check-policy').is(':checked')){
      $('#contactform-submit').prop('disabled', false);
    }
  })

  // スケジュール申し込みフォーム 非会員
  $(function() {
    const non_member_box = $('#non-member-box');
    if(non_member_box) {
      non_member_box.hide();
      if($('input[name="schedule-membership"]').val() === '非会員') {
        non_member_box.show();
      } else {
        non_member_box.hide();
        non_member_box.find('input').val('');
      }
      $('input[name="schedule-membership"]').on('change', function(){
        if($(this).val() === '非会員') {
          non_member_box.show();
        } else {
          non_member_box.hide();
          non_member_box.find('input').val('');
        }
      })
    }
  })

})(jQuery);